import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-486eb1d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scan-schedule-settings" }
const _hoisted_2 = { style: {"margin-left":"8px","color":"var(--cm-color-text-secondary)"} }
const _hoisted_3 = { style: {"font-size":"14px","color":"var(--cm-color-text-secondary)","margin-left":"10px"} }
const _hoisted_4 = { style: {"display":"inline-flex","align-items":"center"} }
const _hoisted_5 = { style: {"margin-left":"8px","color":"var(--cm-color-text-secondary)"} }
const _hoisted_6 = { class: "button-group" }

import { ref, reactive, computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'

import { ScanScheduleSettingsService, ScanScheduleSettings, ScanRule, TriggerType } from './scan-schedule-settings.service'
import { ElMessage } from 'element-plus'
import UpdateTriggerSelector from '@/views/dashboard/_components/update-trigger-selector/update-trigger-selector.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'scan-schedule-settings',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'save', 'cancel'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const props = __props

const emit = __emit

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

const injector = useReflectiveInjector([ScanScheduleSettingsService])
const service = injector.get(ScanScheduleSettingsService)

const formNode = ref()
const loading = ref(false)
const isInitializing = ref(false)

const form = reactive<ScanScheduleSettings>({
  enable: false,
  scan_rule: ScanRule.interval,
  agent_num: 1,
  update_trigger: {} as any
})

function loadSettings () {
  loading.value = true
  isInitializing.value = true
  service.getScanScheduleSettings().then(response => {
    form.enable = response.enable
    form.scan_rule = response.scan_rule || ScanRule.interval
    form.agent_num = response.agent_num || 1
    form.update_trigger = response.update_trigger || {
      type: TriggerType.daily,
      start_time: '09:00',
      day: 1,
      week: 1,
      hour: 1
    }
  }).finally(() => {
    loading.value = false
    isInitializing.value = false
  })
}

async function handleSave () {
  if (!(await checkBeforeSubmit())) {
    return
  }

  loading.value = true
  const params: ScanScheduleSettings = {
    enable: form.enable,
    scan_rule: form.scan_rule,
    agent_num: form.agent_num,
    update_trigger: form.update_trigger
  }

  service.saveScanScheduleSettings(params).then(() => {
    ElMessage.success(t('editSubnet.saveSuccess'))
    emit('save')
    emit('update:modelValue', false)
  }).finally(() => {
    loading.value = false
  })
}

async function checkBeforeSubmit () {
  if (form.enable && form.scan_rule === ScanRule.interval) {
    if (!form.update_trigger?.hour || form.update_trigger.hour < 1 || form.update_trigger.hour > 999) {
      ElMessage.warning(t('scanSchedule.intervalRangeWarning'))
      return false
    }
  }
  if (form.enable && form.scan_rule === ScanRule.scheduled && !form.update_trigger) {
    ElMessage.warning(t('scanSchedule.pleaseSetFrequency'))
    return false
  }
  if (!(await formNode.value?.validate().catch(() => false))) {
    return false
  }
  return true
}

function handleCancel () {
  emit('cancel')
  emit('update:modelValue', false)
}

watch(() => props.modelValue, (val) => {
  if (val) {
    loadSettings()
  }
})



return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogVisible).value = $event)),
    title: _ctx.$t('scanSchedule.title'),
    width: "560px",
    "append-to-body": "",
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          ref_key: "formNode",
          ref: formNode,
          model: form,
          "label-width": "auto",
          "label-position": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('scanSchedule.enableScheduledScan')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: form.enable,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.enable) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('scanSchedule.scanRule')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.scan_rule,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.scan_rule) = $event)),
                  disabled: !form.enable
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      label: _unref(ScanRule).interval
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('scanSchedule.intervalScan')), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_radio, {
                      label: _unref(ScanRule).scheduled
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('scanSchedule.scheduledScan')), 1)
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            (form.scan_rule === _unref(ScanRule).interval)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _ctx.$t('scanSchedule.intervalTime')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: form.update_trigger.hour,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.update_trigger.hour) = $event)),
                      min: 1,
                      max: 999,
                      step: 1,
                      precision: 0,
                      disabled: !form.enable,
                      "controls-position": "right",
                      style: {"width":"100px"},
                      size: "small"
                    }, null, 8, ["modelValue", "disabled"]),
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('scanSchedule.minutes')), 1),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('scanSchedule.intervalTip')), 1)
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (form.scan_rule === _unref(ScanRule).scheduled)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: _ctx.$t('scanSchedule.scanFrequency')
                }, {
                  default: _withCtx(() => [
                    _createVNode(UpdateTriggerSelector, {
                      modelValue: form.update_trigger,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.update_trigger) = $event)),
                      disabled: !form.enable
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('scanSchedule.subnetScanAgent')), 1),
                  _createTextVNode("  "),
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    content: _ctx.$t('scanSchedule.subnetScanAgentTip')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", null, [
                        _createVNode(_component_CmSvgIcon, {
                          name: "assets/icons/info-gray",
                          monochrome: ""
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["content"])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: form.agent_num,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.agent_num) = $event)),
                  min: 1,
                  max: 5,
                  step: 1,
                  precision: 0,
                  disabled: !form.enable,
                  "controls-position": "right",
                  style: {"width":"100px"},
                  size: "small"
                }, null, 8, ["modelValue", "disabled"]),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('scanSchedule.countUnit')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            size: "small",
            onClick: handleCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: handleSave,
            loading: loading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})